export default __webpack_public_path__ + "static/b1-4024ac50cd83fcaf4e9c22e181d13b24.jpg";